import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';

export type SettingsPageSupportSectionProps = React.ComponentProps<'div'> & {
  'data-testid'?: string;
};

export const SettingsPageSupportSection = ({
  className,
  'data-testid': testId,
}: SettingsPageSupportSectionProps) => {

  const supportLinks = [
    {
      label: 'FAQs',
      to: linkoutConfigs.faqs,
    },
    {
      label: 'Contact Customer Service',
      to: linkoutConfigs.contact,
    },
  ] as const;

  const isExternalLink = (url: string) => !url.startsWith('mailto:');

  return (
    <div className={cn('flex flex-col', className)} data-testid={testId}>
      <span className="typography-h2 text-primary mb-6" data-testid="settingsSupport-title">Support</span>

      <Card data-testid="settingsSupport-card">
        <List data-testid="settingsSupport-list">
          {supportLinks.map(({ label, to }) => {
            const itemTestId = `settingsSupport-item-${label.toLowerCase().replace(/\s+/g, '')}`;
            return (
              <ListItem key={label} asChild data-testid={itemTestId}>
                <Link 
                  to={to}
                  {...(isExternalLink(to) && {
                    target: '_blank', 
                  })}
                >
                  {label}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Card>
    </div>
  );
};